import React, { Component, useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Moment from 'moment'
import ShowCategories from './Content/ShowCategories'
import ShowPublished from './Content/ShowPublished'
import ShowAuthor from './Content/ShowAuthor'
import ShowInBrief from './Content/ShowInBrief'
import SearchFilter from './SearchFilter/SearchFilter'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import Pagination from './Pagination'
import { MAXSEARCHRESULTS, SEARCHPAGERANGE, MAXSAVEDSEARCHLIMIT, EDITORIALACCESS, AOISTOIGNORE } from "../utils/constants"
import copy from 'copy-to-clipboard'
import { confirmAlert } from 'react-confirm-alert'
import ShowTopics from './Content/ShowTopics'
import { pushContentToMatomo } from '../utils/matomo'
import { currentUtcDateTime } from '../utils/dateTime'
import helper from '../utils/helper'
import { getHtmlForPdf } from '../utils/getHtmlForPdf'
import CheckBox from '../components/CheckBox'
import { numberWithCommas, stripHTMLFromContent, stringToSEO } from '../utils/stringOps'

var qs = require('qs')

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedAois: [],
      selectedIndustryIds: [],
      selectedGeographyIds: [],
      selectedContentTypeIds: [],
      selectedTopicIds: [],
      selectedDateFrom: undefined,
      selectedDateTo: undefined,
      shouldCallCategoryApi: true,
      selectedContents: 0,
      selectedViewType: sessionStorage.getItem('selectedViewType') == null ? 'full' : sessionStorage.getItem('selectedViewType') , // values = full, title
      clearSearchOnChange: true,
      fileType: 'pdf',
      fileName: '',
      errors: {}
    }

    this.wrapperRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onChangeValue = this.onChangeValue.bind(this)
  }

  componentDidMount() {
    document.title="MLex | Search Result found"
    document.addEventListener("mousedown", this.handleClickOutside)
    if (this.props.user && this.props.location.search) {
      this.callSearchApi()

      this.props.onSavedSearchFetch().then(() => {
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {    

      var searchTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q
      var prevSearchTerm = qs.parse(prevProps.location.search, { ignoreQueryPrefix: true }).q

      if(searchTerm != prevSearchTerm && searchTerm != undefined){
        helper.removeSelectedContentFromSession()
        helper.removeContentViewFromSession()
        this.setState({selectedViewType: 'full'})
      }

      this.callSearchApi()
    }
    
    this.loadSelectedContent()
  }

  callSearchApi = () => {
    var searchTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q
    const pageNum = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).pgn || 1

    var aoiTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).aois
    var aois = aoiTerm !== undefined && aoiTerm !== '' ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).aois.split(',').map(function (x) { return parseInt(x) }) : []

    var industriesTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).industries
    var industries = industriesTerm !== undefined && industriesTerm !== '' ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).industries.split(',').map(function (x) { return parseInt(x) }) : []

    var geosTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).geos
    var geos = geosTerm !== undefined && geosTerm !== '' ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).geos.split(',').map(function (x) { return parseInt(x) }) : []

    var topicsTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).topics
    var topics = topicsTerm !== undefined && topicsTerm !== '' ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).topics.split(',').map(function (x) { return parseInt(x) }) : []

    var contentTypesTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).contentTypes
    var contentTypes = contentTypesTerm !== undefined && contentTypesTerm !== '' ? qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).contentTypes.split(',').map(function (x) { return parseInt(x) }) : []

    var dateFromTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dateFrom
    var dateFrom = dateFromTerm !== undefined && dateFromTerm !== '' ? Moment(dateFromTerm, 'YYYYMMDD').toDate() : undefined

    var dateToTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dateTo
    var dateTo = dateToTerm !== undefined && dateToTerm !== '' ? Moment(dateToTerm, 'YYYYMMDD').toDate() : undefined

    var sortOrderTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).sortOrder
    var sortOrder = sortOrderTerm !== undefined && sortOrderTerm !== '' ? sortOrderTerm : "Relevance"

    var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

    this.setState({
      selectedAois: aois,
      selectedIndustryIds: industries,
      selectedGeographyIds: geos,
      selectedTopicIds: topics,
      selectedContentTypeIds: contentTypes,
      selectedDateFrom: dateFrom,
      selectedDateTo: dateTo,
      selectedContents: selectedContents.length
    })

    const selectedDateFrom = dateFrom
    const selecetdDateTo = dateTo
    const userRole = this.props.user.profile.Role    

    const totalResults = Number(this.props.search.searchResult.totalMatches)
    this.props.onSearch(searchTerm, pageNum, aois, industries, geos, topics, contentTypes, dateFrom, dateTo, sortOrder, userRole).then(() => {

      if (totalResults != 0) {
        const firstPgNum = Math.max(pageNum, 1)
        if (pageNum < firstPgNum) {
          this.handlePageChange(firstPgNum)
        }

        const totalPages = Math.ceil((totalResults === -1 ? MAXSEARCHRESULTS : totalResults) / Number(this.props.search.searchResult.pageSize))
        const lastPgNum = Math.min(pageNum, totalPages)
        if (pageNum > lastPgNum) {
          this.handlePageChange(lastPgNum)
        }
      }

      var totalMatches = Number(this.props.search.searchResult.totalMatches)
      if (totalMatches > 0) {
        this.sortOrderSelect.value = sortOrder
      }

      if (this.state.shouldCallCategoryApi && Number(this.props.search.searchResult.totalMatches) > 0) {
        var dateFrom = selectedDateFrom !== undefined ? Moment(selectedDateFrom).format('YYYYMMDD') : ''
        var dateTo = selecetdDateTo !== undefined ? Moment(selecetdDateTo).format('YYYYMMDD') : ''
        this.props.onSearchCategories(searchTerm, aois, industries, geos, topics, contentTypes, dateFrom, dateTo).then(() => {
          if (totalMatches > 0) {
            this.sortOrderSelect.value = sortOrder

            this.handleScrollPosition()
            
            this.loadSelectedContent()
          }
        })
      }

      this.loadSelectedContent()
    })
  }

  updateAoiSelection(isChecked, selectedValue) {
    var selectedAoi = parseInt(selectedValue)
    if (selectedAoi === 0 && isChecked) {
      this.setState({ selectedAois: [] })
    }
    else {
      if (!isChecked) {
        let selectedAois = Array.from(new Set(this.state.selectedAois.filter(id => id != selectedAoi)))

        this.setState({ selectedAois: selectedAois })
      }
      else {
        const selectedAois = [...this.state.selectedAois, selectedAoi]

        this.setState({ selectedAois: selectedAois })
      }
    }
  }

  updateIndustrySelection(currentNode, selectedNodes) {
    var selectedIndustryId = parseInt(currentNode.value)
    if (selectedIndustryId === 0 && currentNode.checked) {
      this.setState({ selectedIndustryIds: [] })
    }
    else {
      let selectedIndustryIds = Array.from(new Set(selectedNodes.map(item => item.value)))

      this.setState({ selectedIndustryIds: selectedIndustryIds })
    }
  }

  updateGeographySelection(currentNode, selectedNodes) {
    var selectedGeographyId = parseInt(currentNode.value)
    if (selectedGeographyId === 0 && currentNode.checked) {
      this.setState({ selectedGeographyIds: [] })
    }
    else {
      let selectedGeographyIds = Array.from(new Set(selectedNodes.map(item => item.value)))

      this.setState({ selectedGeographyIds: selectedGeographyIds })
    }
  }

  updateTopicSelection(currentNode, selectedNodes) {
    var selectedTopicId = parseInt(currentNode.value)
    if (selectedTopicId === 0 && currentNode.checked) {
      this.setState({ selectedTopicIds: [], clearSearchOnChange: true })
    }
    else {
      let selectedTopicIds = Array.from(new Set(selectedNodes.map(item => item.value)))

      this.setState({ selectedTopicIds: selectedTopicIds, clearSearchOnChange: false })
    }
  }

  updateContentTypeSelection(isChecked, selectedValue) {
    var selectedContentTypeId = parseInt(selectedValue)
    if (selectedContentTypeId === 0 && isChecked) {
      this.setState({ selectedContentTypeIds: [] })
    }
    else {
      if (!isChecked) {
        let selectedContentTypeIds = Array.from(new Set(this.state.selectedContentTypeIds.filter(id => id != selectedContentTypeId)))

        this.setState({ selectedContentTypeIds: selectedContentTypeIds })
      }
      else {
        const selectedContentTypeIds = [...this.state.selectedContentTypeIds, selectedContentTypeId]

        this.setState({ selectedContentTypeIds: selectedContentTypeIds })
      }
    }
  }

  updateDateRangeSelection(DateFrom, DateTo) {
    this.setState({
      selectedDateFrom: DateFrom,
      selectedDateTo: DateTo
    })
  }

  applySelection = (id) => {

    if (!(this.state.selectedDateFrom > this.state.selectedDateTo)) {
      var searchTerm = encodeURIComponent(qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q)

      const aois = this.state.selectedAois.length > 0 ? this.state.selectedAois.join() : ''
      const industries = this.state.selectedIndustryIds.length > 0 ? this.state.selectedIndustryIds.join() : ''
      const geos = this.state.selectedGeographyIds.length > 0 ? this.state.selectedGeographyIds.join() : ''
      const topics = this.state.selectedTopicIds.length > 0 ? this.state.selectedTopicIds.join() : ''
      const contentTypes = this.state.selectedContentTypeIds.length > 0 ? this.state.selectedContentTypeIds.join() : ''
      const dateFrom = this.state.selectedDateFrom !== undefined ? Moment(this.state.selectedDateFrom).format('YYYYMMDD') : ''
      const dateTo = this.state.selectedDateTo !== undefined ? Moment(this.state.selectedDateTo).format('YYYYMMDD') : ''
      var sortOrderQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).sortOrder
      var sortOrder = sortOrderQueryString !== undefined ? sortOrderQueryString : 'Relevance'

      this.setState({ shouldCallCategoryApi: true }, () => {
        var searchUrl = `/search?q=${searchTerm}&aois=${aois}&industries=${industries}&geos=${geos}&topics=${topics}&contentTypes=${contentTypes}&dateFrom=${dateFrom}&dateTo=${dateTo}&sortOrder=${sortOrder}&pgn=1`
        this.props.history.push(searchUrl)

        var selectedAoi = aois.split(',')
        var finalAois = this.props.searchCategories.searchCatResult.categories.filter(a=> (a.type === 20) && selectedAoi.some(i => i == a.id)).map(a => a.name).flat()

        var selectedGeos = geos.split(',')
        var finalGeos = this.props.searchCategories.searchCatResult.categories.filter(a=> (a.type === 5 || a.type === 6 || a.type === 7) && selectedGeos.some(i => i == a.id)).map(a => a.name).flat()
       
        var selectedInds = industries.split(',')
        var finalInds = this.props.searchCategories.searchCatResult.categories.filter(a=> a.type === 3 && selectedInds.some(i => i == a.id)).map(a => a.name).flat()

        var selectedCts = contentTypes.split(',')
        var finalCts = this.props.searchCategories.searchCatResult.contentTypes.filter(a=> selectedCts.some(i => i == a.id)).map(a => a.name).flat()
        
        var selectedTopics = topics.split(',')
        var finalTopics = this.props.searchCategories.searchCatResult.topics.filter(a=> selectedTopics.some(i => i == a.id)).map(a => a.name).flat()
        
        var contextData = {
          Aoi: finalAois,
          Industries: finalInds,
          Geographies: finalGeos,
          Topics: finalTopics,
          ContentTypes: finalCts,
          DateFrom: dateFrom,
          DateTo: dateTo,
          SortOrder: sortOrder,
          SearchTerm: searchTerm,
          SearchUrl: searchUrl
        }

        var uiEvent = ''

        if(id.includes('Top')){
            uiEvent='results_applyfiltertop'
        }
        else {
          uiEvent='results_applyfilterbottom'
        }

        pushContentToMatomo(uiEvent, 'content', 'search_results', 'click', 'Apply', contextData)

        window.scrollTo(0, 0)
      })
    }
  }

  resetSelection = () => {
    var searchTerm = encodeURIComponent(qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q)

    this.setState({
      shouldCallCategoryApi: true,
      selectedAois: [],
      selectedIndustryIds: [],
      selectedGeographyIds: [],
      selectedTopicIds: [],
      selectedContentTypeIds: [],
      selectedDateFrom: undefined,
      selectedDateTo: undefined
    }, () => {
      this.props.history.push(`/search?q=${searchTerm}&pgn=1`)
      window.scrollTo(0, 0)
    })
  }

  handlePageChange(pageNumber) {
    var sortOrderQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).sortOrder
    var sortOrder = sortOrderQueryString !== undefined ? sortOrderQueryString : ''

    this.handleChange(pageNumber, sortOrder)
  }

  sortOrderChange = () => {
    this.handleChange(1, this.sortOrderSelect.value)

    pushContentToMatomo('results_changesortorder', 'content', 'search_results', 'click', this.sortOrderSelect.value, {})
  }

  handleChange(pageNumber, sortOrder) {
    var searchTerm = encodeURIComponent(qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q)

    var aoiQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).aois
    var aois = aoiQueryString !== undefined ? aoiQueryString : ''

    var industriesQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).industries
    var industries = industriesQueryString !== undefined ? industriesQueryString : ''

    var geosQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).geos
    var geos = geosQueryString !== undefined ? geosQueryString : ''

    var topicQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).topics
    var topics = topicQueryString !== undefined ? topicQueryString : ''

    var contentTypesQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).contentTypes
    var contentTypes = contentTypesQueryString !== undefined ? contentTypesQueryString : ''

    var dateFromQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dateFrom
    var dateFrom = dateFromQueryString !== undefined ? dateFromQueryString : ''

    var dateToQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dateTo
    var dateTo = dateToQueryString !== undefined ? dateToQueryString : ''

    this.setState({ shouldCallCategoryApi: false }, () => {
      this.props.history.push(`/search?q=${searchTerm}&aois=${aois}&industries=${industries}&geos=${geos}&topics=${topics}&contentTypes=${contentTypes}&dateFrom=${dateFrom}&dateTo=${dateTo}&sortOrder=${sortOrder}&pgn=${pageNumber}`)
      window.scrollTo(0, 0)
    })
  }

  copyUrl = (e) => {
    e.preventDefault()
    copy(window.location.href)

    confirmAlert({
      title: 'Link copied',
      message: 'The link for this search has been copied',
      buttons: [
        {
          label: 'Close',
          onClick: () => { }
        }
      ]
    });
  }

  cancelDownload = () => {
    var downloadDialog = document.getElementById('div-download-overlay')
    downloadDialog.style.display = 'none'
  }

  showDownloadDialog = (e) => {
    e.preventDefault()

    var downloadDialog = document.getElementById('div-download-overlay')

    var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

    if(selectedContents.length > 1) {
      this.setState({fileName : 'MLex Articles'})
    } 
    else {
      if (selectedContents.length === 0) {
        this.setState({fileName : ''})
      } 
      else {
        this.setState({fileName : `MLex_${stripHTMLFromContent(selectedContents[0].title)}`})
      }
    }

    if(downloadDialog.style.display == 'none' || downloadDialog.style.display == ''){
      downloadDialog.style.display = 'flex'
      this.setState({ errors: {} })
    }
  }

  isValid = () => {
    let errors = {}
    const downloadFileNameValidationError = this.validateName(this.state.fileName)

    if (downloadFileNameValidationError) {
        errors["downloadFileName"] = downloadFileNameValidationError
    }
    this.setState({ errors: errors })
    if (Object.keys(errors).length > 0) {
        return false
    }
    return true
  }

  validateName = (inputString) => {
    if (!inputString || inputString.trim() === '') {
      return `Please enter a name for the file in order to download it`
    } else {
      if (inputString.length > 255) {
        return `The name of your file is too long. Please adjust it to contain less than 255 characters.`
      }
  
      const pattern = /^[^:*?"<>|/\\]+$/g
      if (!pattern.test(inputString)) {
        return `<p>Your filename cannot contain any of the following characters: </p>
               <ul>
                  <li style="list-style: none;"><strong> / \ : * ? " < > | </li>
               </ul>`
      }
    }
    return null
  }

  downloadPdf = (e) => {
    e.preventDefault()

    if (this.isValid()) {
      var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

      var request = {
        htmlFiles: [],
        userEmail: this.props.user.profile.name,
        fileType: this.state.fileType,
        fileName: this.state.fileName
      }
      var itemsProcessed = 0;
  
      selectedContents.forEach((content, index) => { 
        if(index === 0) {
          document.getElementById('iframe-search').src = `${process.env.APP_BASE_URL}/#/content/${selectedContents[0].id}?source=iframe` 
        }
        
        this.cancelDownload()
        document.getElementById('divDownloading').className = 'show-download'        
                    
        setTimeout(() => {
          var sanitizedFilename = `MLex_${stripHTMLFromContent(content.title)}_${content.id}.pdf`
          sanitizedFilename = sanitizedFilename.replace(/[:*?"<>|/\\]/g, '_')

          let isPortfolio = false
          if (content.contentTypeName == 'Portfolio') {
            isPortfolio = true
          }

          var file = {
            filename: sanitizedFilename,
  
            // Need to pass isPortfolio dynamically to below method
            content: getHtmlForPdf(isPortfolio, content.id, 'search')
          }
  
          request.htmlFiles = [...request.htmlFiles, file]
  
          itemsProcessed++;
            
          if(itemsProcessed === selectedContents.length) {
            this.generatePdf(request)
          } else {
            document.getElementById('iframe-search').src = `${process.env.APP_BASE_URL}/#/content/${selectedContents[index + 1].id}?source=iframe`
          }          
        }, (index + 1) * 3000)
      }); 
    }         
  } 

  generatePdf (request) {
    this.props.onPdfFetch(request).then((response) => {  
      if (this.props.fetchPdf && this.props.fetchPdf.error !== '') {
        confirmAlert({
          title: 'PDF Download Failed',
          message: `Sorry, but we have encountered a problem downloading the selected result(s) to PDF.
Please re-try.  If the problem persists, please contact the MLex Customer Services (customerservices@mlex.com) and provide this error message.
          ${this.props.fetchPdf.error.toString()}`,
          buttons: [
            {
              label: 'Close',
              onClick: () => { }
            }
          ]
        })
  
        this.props.fetchPdf.error = ''
      }
      else {
        var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

        selectedContents.forEach((content, index) => { 
          this.pushPdfFromSearchToMatomo(content.id, content.title, content.contentTypeName, content.aois)
        })

        helper.removeSelectedContentFromSession()
        this.setState({selectedContents: 0, fileType: 'pdf'})
      }
    })
  }

  onChangeValue(event) {
    this.setState({ fileType: event.target.value })
  }

  updateNameState = (e) => {
    const downloadFileName = e.target.value
    
    this.setState({ fileName: downloadFileName })

    //reset the validation error 
    const downloadFileNameValidationErrors = this.validateName(downloadFileName)
    if (!downloadFileNameValidationErrors) {
        let errorObj = this.state.errors
        delete errorObj.downloadFileName
        this.setState({ errors: errorObj })
    }
}

  saveSearchClick = (e) => {
    if (this.props.userSearches.savedSearches.length >= MAXSAVEDSEARCHLIMIT) {      
      e.preventDefault()

      confirmAlert({
        title: 'Unable to save search',
        message: 'You have reached the maximum permitted \nnumber. You must delete an existing saved search \nbefore you can add a new one.',
        buttons: [
          {
            label: 'Close',
            onClick: () => { }
          }
        ]
      });
    }
    else {
      helper.removeSelectedContentFromSession()
      helper.removeContentViewFromSession()
    }
  }

  loadSkeleton = (key) => {
    return(
      <article key={key}>
        <Skeleton height={40} count={1} /><br />
        <Skeleton count={2} /><br /><br />
        <Skeleton count={3} /><br /><br />
        <Skeleton count={1} /><br /><br />
      </article>
    )
  }

  pushPdfFromSearchToMatomo(contentId, contentTitle, contentType, aois){
    var contextData = {
      contentId: contentId,
      articleTitle: contentTitle,
      contentType: contentType,
      areasOfInterest: aois
    }
  
    pushContentToMatomo('delivery_download_searchresults', 'content', 'search_results', 'click', 'PDF', contextData)
  }

   // handle scroll position after content load
   handleScrollPosition = () => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
      sessionStorage.removeItem("scrollPosition");
    }
  };


  setScrollPosition() {
    sessionStorage.setItem("scrollPosition", window.pageYOffset);
  }

  selectContent = (checked, value, content) => {
    var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

    if(checked){
      selectedContents = [{ id: value, title: content.title, contentTypeName: content.contentType.name, aois: content.aoi.map(x=>x.name).flat()}, ...selectedContents]

      sessionStorage.setItem("selectedContents", JSON.stringify(selectedContents));
    }
    else {
      selectedContents = selectedContents.filter(content => content.id != value)

      sessionStorage.setItem("selectedContents", JSON.stringify(selectedContents));
    }

    this.setState({selectedContents : selectedContents.length}, function() {
      this.loadSelectedContent()
    })
  }

  loadSelectedContent = () => {
    var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))

    selectedContents.forEach(content => {
      if(document.getElementById('content-div-'+ content.id) != undefined){
        document.getElementById('content-div-'+ content.id).className='content-item selected'
        document.getElementById('cb-'+ content.id).checked = true
      }
    });
  }

  toggleSelectedContents = (event) => {
    event.preventDefault()
    var selectedContentsDiv = document.getElementById('div-selected-contents')

    if(selectedContentsDiv.style.display == 'none' || selectedContentsDiv.style.display == ''){
      selectedContentsDiv.style.display = 'block'
    }
    else {
      selectedContentsDiv.style.display = 'none'
    }
  }

  handleClickOutside(event) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      var selectedContentsDiv = document.getElementById('div-selected-contents')
      selectedContentsDiv.style.display = 'none'
    }
  }

  selectViewType = (event, value) => {
    event.preventDefault()

    this.setState({selectedViewType: value})
    sessionStorage.setItem("selectedViewType", value)
  }

  removeSelectedItem = (event, contentId) => {
    event.preventDefault()
    var selectedContents = sessionStorage.getItem("selectedContents") == null ? [] : JSON.parse(sessionStorage.getItem("selectedContents"))
    selectedContents = selectedContents.filter(content => content.id != contentId)

    sessionStorage.setItem("selectedContents", JSON.stringify(selectedContents));

    this.setState({selectedContents : selectedContents.length}, function() {
      this.loadSelectedContent()
    })
  }

  clearSelectedItems = () => {
    helper.removeSelectedContentFromSession()

    this.setState({selectedContents : 0}, function() {
      this.loadSelectedContent()
    })
  }

  confirmClearSelection = (event) => {
    event.preventDefault()
    confirmAlert({
      title: 'Clear Selected Results',
      message: 'Are you sure you want to remove all selected result(s)?',
      buttons: [        
        {
          label: 'Confirm',
          onClick: () => {
            this.clearSelectedItems()
          }
        },
        {
          label: 'Cancel',
          onClick: () => { this.toggleSelectedContents(event) }
        }
      ]
    });
  }

  render() {
    let skeleton = []
    for (let i = 0; i < 3; ++i) {
      skeleton.push(this.loadSkeleton(i))
    }

    const errors = this.state.errors

    const pageNum = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).pgn || 1

    const numberOfSelectedContents = this.state.selectedContents

    if (this.props.user && this.props.search.fetching === false) {
      const ShowContent = ({ apiData }) => (
        <>
          {apiData.documents
            .map((content, index) => (
              <article className='content-wrapper' key={content.contentId}>
                <div className='content-selection'>
                  <span>{((pageNum - 1) * 20) + index + 1}</span>
                  <CheckBox
                  id={`cb-${content.contentId}`}
                  Checked={sessionStorage.getItem("selectedContents") != null && JSON.parse(sessionStorage.getItem("selectedContents")).filter(c => c.id == content.contentId).length != 0}
                  Value={content.contentId}
                  Name={`cb-${content.contentId}`}
                  onTickChanged={(chk, val) => this.selectContent(chk, val, content)}
                />
                </div>
                <div className='content-item' id={`content-div-${content.contentId}`}>
                  <h2 className='article-title'>
                    <a className='hyperLink' href={`/#/content/${content.contentId}/${stringToSEO(content.title)}?referrer=search_linkclick`} onClick = {this.setScrollPosition} 
                      dangerouslySetInnerHTML={{__html: content.title}} />
                  </h2>
                  <div className='article-published '>
                    <ShowPublished published={content.publicationDate} contentTypeName={content.contentType.name} productType={this.props.user.profile.Product} 
                    showTooltip={true} issuingEntity={content.issuingEntity} documentType={content.documentType}/>                    
                  </div>
                  <ShowAuthor author={content.author} clickable={true} />
                  {this.state.selectedViewType == 'full' ?                    
                    <ShowInBrief inBrief={content.inBrief} issuingEntity={content.issuingEntity} documentType={content.documentType} />                                         
                    : null
                  }                  
                  <div className='article-tags'>
                    <div className='article-tag'>
                      <ShowCategories title='Areas of Interest' categories={this.props.user.profile.Role == EDITORIALACCESS ? content.aoi : content.aoi.filter(a=> !AOISTOIGNORE.includes(a.id))}/>
                    </div>
                    <div>
                      <ShowTopics title='Topics' topics={content.topics} isSearchPage />
                    </div>
                  </div>
                </div>
              </article>
            ))}
        </>
      )

      if (this.props.search.error !== '') {
        this.props.search.error = ''
        return <Redirect to='/error' />
      } else {
        if (this.props.search.searchResult.documents && this.props.search.fetching === false && this.props.searchCategories.fetching === false) {
          var searchTerm = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).q
          const pageNum = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).pgn
          var dateToQueryString = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).dateTo
          var dateTo = dateToQueryString !== undefined ? dateToQueryString : ''

          return (
            <>
            <div className='grid-content-top content-search'>
            <div className={this.props.search.searchResult.totalMatches != 0 ? 'header-message section-border' : 'header-message'}>
                  {this.props.search.searchResult.phrase === null ?
                    <p>You did not enter a search term.  <a className='hyperLink' href={`/#/search?q=*`}>Load all our content</a></p>
                    :
                    (
                      this.props.search.searchResult.hasError === false ?
                        (
                          this.props.search.searchResult.totalMatches === 0 ?
                            (
                              pageNum != undefined ?
                                <div className='message alert alert-warning'>
                                  No results found for your selected filters.<br />
                                  Please adjust your selection.
                                </div>
                                : <div className="message-wrapper">
                                  <p>There were no results found for the search: <strong>{searchTerm}</strong>.</p>
                                  <p>Widen your search phrase to find more results.</p>
                                </div>
                            )
                            :
                            <>
                              <div className="result-wrapper">
                                <div className="result-message">
                                  <h1><strong>{this.props.search.searchResult.totalMatches >= 9999 ? '9,999+' : numberWithCommas(this.props.search.searchResult.totalMatches.toLocaleString())} results found for:</strong> {searchTerm}</h1>
                                </div>
                                <div className='view-type-container'>
                                  <ul>
                                    <li> <a className='view-type-wrapper' id='aFullView' href='#' target='_self' rel='noopener noreferrer' onClick={(event) => this.selectViewType(event, 'full')}>
                                      <span id="spanFullView" aria-label='Full view - Results show title, summary, publish date/time, content type and tags' className={this.state.selectedViewType == 'full' ? 'view-type-icon tooltip active' : 'view-type-icon tooltip'}></span>
                                    </a></li>
                                    <li> <a className='view-type-wrapper' id='aTitleView' href='#' target='_self' rel='noopener noreferrer' onClick={(event) => this.selectViewType(event, 'title')}>
                                      <span id="spanTitleView" aria-label='Title view - Results show title, publish date/time, content type and tags' className={this.state.selectedViewType == 'title' ? 'view-type-icon tooltip active' : 'view-type-icon tooltip'}></span>
                                    </a></li>
                                  </ul>
                                </div>
                              </div>
                              
                            </>
                        )
                        :
                        (
                          this.props.search.searchResult.clientError != null ?
                            <div className='message alert alert-warning'>
                              Search failed: {this.props.search.searchResult.clientError}
                            </div>
                            :
                            <div className='message alert alert-warning'>
                              Search failed: {this.props.search.searchResult.serverError}
                            </div>
                        )
                    )
                  }
                </div>
            </div>
              <div className='grid-content-left'>
                {(this.props.searchCategories.searchCatResult.categories && (this.props.search.searchResult.totalMatches != 0 || pageNum != undefined)) ?
                  <SearchFilter filterCategories={this.props.searchCategories.searchCatResult}
                    selectedAois={this.state.selectedAois}
                    onAoiChanged={(chk, val) => this.updateAoiSelection(chk, val)}
                    selectedIndustryIds={this.state.selectedIndustryIds}
                    onIndustryChanged={(chk, val) => this.updateIndustrySelection(chk, val)}
                    selectedGeographyIds={this.state.selectedGeographyIds}
                    onGeographyChanged={(chk, val) => this.updateGeographySelection(chk, val)}
                    selectedContentTypeIds={this.state.selectedContentTypeIds}
                    onTopicChanged={(chk, val) => this.updateTopicSelection(chk, val)}
                    selectedTopicIds={this.state.selectedTopicIds}
                    clearSearchOnChange={this.state.clearSearchOnChange}
                    onContentTypeChanged={(chk, val) => this.updateContentTypeSelection(chk, val)}
                    selectedDateFrom={this.state.selectedDateFrom}
                    selectedDateTo={this.state.selectedDateTo}
                    onDateRangeChanged={(dateFrom, dateTo) => this.updateDateRangeSelection(dateFrom, dateTo)}

                    onApplySelection={(id) => this.applySelection(id)}
                    onResetSelection={(id) => this.resetSelection(id)} 
                    ignoreAois = {this.props.user.profile.Role == EDITORIALACCESS ? false : true }/>
                : null }
              </div>
                <div className='grid-content-right content-search'>
                {(this.props.search.searchResult.totalMatches != 0) ?
                  <>
                  <div className='search-buttons'>
                    <div className='save-search-button-wrapper'>
                      {numberOfSelectedContents > 0
                        ?
                        <div ref={this.wrapperRef} className='content-selected'>                          
                          <a className='content-selected-icon tooltip' aria-label='View Selection(s)' id='contentSelection' href='#' onClick={(event) => this.toggleSelectedContents(event)}>
                            <span>{numberOfSelectedContents} SELECTED</span>
                          </a>
                          <div id='div-selected-contents' className='selected-contents'>
                            <div id='selectedContentsHeader' className='selected-contents-header'>
                              <span className="header-text" id="headerText">Selected Items</span>
                              <a className='pure-button secondary-action' id="clearAllSelection" onClick={(event) => this.confirmClearSelection(event)} href='#'>
                                <span className='clear-all-button-icon'>Clear All</span>
                              </a>
                            </div>
                            {sessionStorage.getItem("selectedContents") != null ? 
                              JSON.parse(sessionStorage.getItem("selectedContents")).map
                              ((content) => 
                                <span className='selected-row' key={content.id} id={`selectedRow${content.id}`}>
                                  <span className='selected-title' id={`selectedTitle${content.id}`}>{stripHTMLFromContent(content.title)}</span>
                                  <a className='selected-delete-button' id={`delSelectedRow${content.id}`} href='#' onClick={(event) => this.removeSelectedItem(event, content.id)}></a>
                                </span>
                              ) : null}
                          </div>
                        </div>
                        : null}
                      <Link className='search-action-button tooltip' id='btnSaveSearch' aria-label='Save this search and set alerts' onClick={event => this.saveSearchClick(event)} to={{
                        pathname: '/SaveSearch',
                        state: { searchUrl: window.location.href, searchTerm: searchTerm, dateTo: dateTo }
                      }}>
                        <span className='search-action-button-icon'></span>
                        <span className='button-icon-text font-14'>Save Search</span>
                      </Link>

                      <a className='search-action-button tooltip' id='btnCopyLink' aria-label='Copy shareable link for this search' href='#' onClick={this.copyUrl}
                        data-gm-u-pn="content"
                        data-gm-u-c="search_results"
                        data-gm-u-e="search_permalink"
                        data-gm-u-v='Link'
                        data-gm-u-a="click">
                        <span className='search-action-button-icon'></span>
                        <span className='button-icon-text font-14'>Link</span>
                      </a>
                      {numberOfSelectedContents > 0
                        ?
                        <div>
                          <a className='search-action-button tooltip' id='btnPdf' aria-label='Download selected content(s) to PDF' href='#' onClick={this.showDownloadDialog}>
                            <span className='search-action-button-icon'></span>
                            <span className='button-icon-text font-14'>PDF</span>
                          </a>
                          <div id='div-download-overlay' className='download-overlay'>
                            <div id='div-download-dialog' className='download-dialog'>
                              <div id='downloadHeader' className='download-header'>
                                <span>Download Selected Results</span>                              
                              </div>
                              {Object.keys(errors).length > 0 &&
                                <div className='alert alert-error'>
                                    <p dangerouslySetInnerHTML={{ __html: this.state.errors["downloadFileName"] }}></p>
                                </div>}
                              <div className='download-format'>
                                <span>Document Format:</span>
                                <select id='downloadFormatSelect'
                                  ref={input => {
                                    this.downloadFormatSelect = input
                                  } }>
                                  <option value='Pdf'>Portable Document Format (PDF)</option>
                                </select>
                              </div>
                              <div className='download-file-type' onChange={this.onChangeValue}>
                                <div className='download-type-radio'>                            
                                  <input type='radio' value='pdf' name='fileType' defaultChecked='true' /> 
                                  <span>Download all articles as a single PDF</span>
                                </div>
                                <div className='download-type-radio'>
                                  <input type='radio' value='zip' name='fileType' /> 
                                  <span>Download all articles as separate PDFs in a Zip file</span>
                                </div>
                              </div>
                              <div className='download-file-name'>
                                  <span>Filename</span>
                                  <input className={`input ${this.state.errors["downloadFileName"] ? 'error-input' : ''}`} type='text' id='downloadFileName'
                                        ref={input => { this.downloadFileName = input }} maxLength="255"
                                        onChange={event => this.updateNameState(event)} value={this.state.fileName} />
                              </div>
                              <div className='download-buttons-section'>                                
                                <button id='downloadConfirm' name='download-confirm-button' className='pure-button primary-action' onClick={event => this.downloadPdf(event)}>Download</button>
                                <button id='downloadCancel' name='download-cancel-button' className='pure-button secondary-action' 
                                  onClick={event => this.cancelDownload()}>Cancel</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      : null }
                    </div>
                    <div className='result-order'>
                      <span>Sort by:</span>
                      <select id='sortOrderSelect'
                        ref={input => {
                          this.sortOrderSelect = input
                        } }
                        onChange={this.sortOrderChange}>
                        <option value='Relevance'>Relevance</option>
                        <option value='Newest'>Newest</option>
                        <option value='Oldest'>Oldest</option>
                      </select>
                    </div>
                  </div>
                  <ShowContent apiData={this.props.search.searchResult} />
                  <Pagination currentPageNumber={this.props.search.searchResult.pageNumber}
                    totalItemsCount={this.props.search.searchResult.totalMatches}
                    pageRangeDisplayed={SEARCHPAGERANGE}
                    itemsCountPerPage={this.props.search.searchResult.pageSize}
                    onPageChange={(cur) => this.handlePageChange(cur)} />
                </>
                : null }
              </div>
            </>)
        }
        else {
          return (
            <>
              <div className='grid-content-left'>
                <Skeleton count={20} />
              </div>
              <div className='grid-content-full skeleton content-search'>
                <Skeleton count={1} /><br /><br />
                {skeleton}               
              </div>
            </>
          )
        }
      }
    } else {
      
      return (
        <>
          <div className='grid-content-left'>
            <Skeleton count={20} />
          </div>
          <div className='grid-content-full skeleton content-search'>
            <Skeleton count={1} /><br /><br />
            {skeleton}
          </div>
        </>
      )
    }
  }
}


function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    search: state.search,
    searchCategories: state.searchCategories,
    userSearches: state.userSearches,
    fetchPdf: state.fetchPdf
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSearch: (searchTerm, pageNumber, aois, industries, geos, topics, contentTypes, dateFrom, dateTo, sortOrder, userRole) => new Promise((resolve, reject) => {
    dispatch(actions.searchContent(searchTerm, '', pageNumber, aois, industries, geos, topics, contentTypes, dateFrom, dateTo, sortOrder, userRole)).then(() => {
      resolve();
    })
  }),
  onSearchCategories: (searchTerm, aois, industries, geos, topics, contentTypes, dateFrom, dateTo) => new Promise((resolve, reject) => {
    dispatch(actions.searchCategories(searchTerm, aois, industries, geos, topics, contentTypes, dateFrom, dateTo)).then(() => {
      resolve();
    })
  }),
  onSavedSearchFetch: () => new Promise((resolve, reject) => {
    dispatch(actions.fetchSavedSearches()).then(() => {
      resolve();
    })
  }),
  onPdfFetch: (payload) => new Promise((resolve, reject) => {
    dispatch(actions.fetchAndSavePdfContent(payload)).then(() => {
      resolve();
    })
  })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)
